import { client } from "../client";
import type { Announcement } from "../types/announcement.types";

export const updateAnnouncement = async ({
	type,
	content,
	title,
	published,
	style,
}: Partial<Announcement>) => {
	const response = await client.patch<Announcement>(`/announcements/`, {
		type,
		title,
		content,
		published,
		style,
	});
	return response.data;
};
